import React, {CSSProperties} from "react";
import {TicketAirlineLogoComponent} from "../segments/ticket-airline-logo.component";
import {TicketRecordLocatorComponent} from "../segments/ticket-record-locator.component";
import {IBookingViewModel} from "../../../services/booking/models/booking-view-model.interface";

export const TicketPageHeaderComponent: React.FC<{booking: IBookingViewModel;}> = (props) => {
    const styles: CSSProperties = {
        display: "flex",
        flexDirection: "row",
        alignItems: "baseline",
        justifyContent: "space-between",
        width: "100%"
    }
    return (
        <div style={styles}>
            <TicketAirlineLogoComponent/>
            <TicketRecordLocatorComponent recordLocator={props.booking.recordLocator ?? ""}/>
        </div>
    )
}
